(function () {
  var S3 = 'https://saintpixel-images.s3.eu-west-3.amazonaws.com/coa';

  // Read serial: hash fragment first (survives Shopify Markets redirects),
  // then query param fallback for backward compat
  var serial = window.location.hash.replace(/^#/, '') || null;
  if (!serial) serial = new URLSearchParams(window.location.search).get('serial');

  var wrap = document.querySelector('[data-sp-coa]');
  if (!wrap) return;
  var fr = (wrap.dataset.locale || 'en') === 'fr';
  var badge = wrap.querySelector('[data-sp-badge]');
  var btext = wrap.querySelector('[data-sp-badge-text]');
  var body = wrap.querySelector('[data-sp-body]');

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function fmtDate(iso) {
    if (!iso) return '\u2014';
    var d = new Date(iso);
    if (isNaN(d)) return esc(iso);
    return fr
      ? d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })
      : d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }

  function setBadge(valid, text) {
    badge.className = 'caption-with-letter-spacing sp-coa-badge ' + (valid ? 'sp-coa-badge--valid' : 'sp-coa-badge--invalid');
    btext.innerHTML = (valid ? '\u2713' : '\u2717') + '&nbsp;' + text;
  }

  function showMissing() {
    setBadge(false, fr ? 'Num\u00e9ro de s\u00e9rie manquant' : 'Missing serial number');
    body.innerHTML = '<p>' + (fr
      ? "Veuillez utiliser le lien fourni dans votre email d\u2019exp\u00e9dition ou scanner le QR code sur votre certificat PDF."
      : 'Please use the link provided in your shipping confirmation email, or scan the QR code on your PDF certificate.') + '</p>';
  }

  function showNotFound(s) {
    setBadge(false, fr ? 'Certificat introuvable' : 'Certificate not found');
    body.innerHTML = '<div class="sp-coa-serial h5">' + esc(s) + '</div><p>'
      + (fr ? "Ce num\u00e9ro de s\u00e9rie ne correspond \u00e0 aucun certificat dans notre registre."
           : 'This serial number does not match any certificate in our registry.') + '</p>';
  }

  function showCert(c) {
    setBadge(true, fr ? 'Authenticit\u00e9 v\u00e9rifi\u00e9e' : 'Authenticity verified');
    var firstHash = c.items && c.items.length && c.items[0].hash8 ? c.items[0].hash8 : null;
    var titleHtml = esc(c.product_title || '\u2014');
    if (firstHash) titleHtml += '<br><span style="font-size:.8em;opacity:.45;font-family:monospace">#' + esc(firstHash) + '</span>';
    var rows = fr ? [
      ['Titre', titleHtml],
      ['Artiste', 'SaintPixel'],
      ['Date de commande', fmtDate(c.created_at || c.order_date)],
      ['Technique', esc(c.technique || 'Gicl\u00e9e sur papier Fine Art')],
      ['Format', esc(c.dimensions || '\u2014')],
      ['\u00c9dition', 'Tirage ouvert / Open Edition']
    ] : [
      ['Title', titleHtml],
      ['Artist', 'SaintPixel'],
      ['Order date', fmtDate(c.created_at || c.order_date)],
      ['Technique', esc(c.technique || 'Gicl\u00e9e Fine Art paper')],
      ['Format', esc(c.dimensions || '\u2014')],
      ['Edition', 'Open Edition']
    ];
    var h = '<div class="sp-coa-serial h5">' + esc(c.serial) + '</div><table class="sp-coa-table">';
    rows.forEach(function (r) { h += '<tr><td class="caption">' + r[0] + '</td><td>' + r[1] + '</td></tr>'; });
    h += '</table>';
    if (c.pdf_url) {
      h += '<a class="sp-coa-pdf caption-with-letter-spacing" href="' + esc(c.pdf_url) + '" target="_blank">'
        + (fr ? '\u2193 T\u00e9l\u00e9charger le certificat PDF' : '\u2193 Download PDF certificate') + '</a>';
    }
    if (c.signature) {
      h += '<details class="sp-coa-sig"><summary class="caption">'
        + (fr ? 'V\u00e9rification cryptographique (Ed25519)' : 'Cryptographic verification (Ed25519)')
        + '</summary><div class="sp-coa-sig__body"><p class="caption">'
        + (fr ? "Ce certificat a \u00e9t\u00e9 sign\u00e9 \u00e0 l\u2019\u00e9mission. V\u00e9rifiable ind\u00e9pendamment avec la cl\u00e9 publique ci-dessous."
             : 'This certificate was signed at issuance. Independently verifiable using the public key below.')
        + '</p><p class="caption-with-letter-spacing" style="color:rgba(var(--color-foreground),.4);margin-top:10px;">Signature</p>'
        + '<code>' + esc(c.signature) + '</code>'
        + '<p class="caption-with-letter-spacing" style="color:rgba(var(--color-foreground),.4);margin-top:8px;">'
        + (fr ? 'Cl\u00e9 publique' : 'Public key') + '</p>'
        + '<code>' + esc(c.public_key) + '</code></div></details>';
    }
    body.innerHTML = h;
  }

  if (!serial) { showMissing(); return; }
  fetch(S3 + '/' + encodeURIComponent(serial) + '/verify.json')
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(showCert)
    .catch(function () { showNotFound(serial); });
})();
